/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type InternalPostCompleteUnverifiedMemberSignupCookieRequestBody = OperationRequestBodyContent<
  operations['internalPostCompleteUnverifiedMemberSignupCookie']
>;

export interface Input {
  apiVersion?: string;
  body: InternalPostCompleteUnverifiedMemberSignupCookieRequestBody;
}

export async function internalPostCompleteUnverifiedMemberSignupCookie(
  { apiVersion, body }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST('/internal/account/signup/complete', {
    params: {},
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
